if (!customElements.get('price-radios')) {
  class PriceRadios extends HTMLElement {
    constructor() {
      super();

      this.priceRange = document.querySelector('price-range');
    }

    connectedCallback() {
      this.addEventListener('input', (e) => {
        e.stopPropagation();

        const min = e.target.value.split('-')[0];
        const max = e.target.value.split('-')[1];

        this.priceRange.fromInput.value = +min === 0 ? null : min;
        this.priceRange.toInput.value = +max === 0 ? null : max;

        this.priceRange.fromInput.dispatchEvent(new Event('input', { bubbles: !0 }))
        this.priceRange.toInput.dispatchEvent(new Event('input', { bubbles: !0 }))
      });
    }
  }

  customElements.define('price-radios', PriceRadios);
}
